import { TypeOfSelectors } from "app/pages/sales-intelligence/common-components/MultiSelector/types";
import type { MultiSelectorPanelType } from "app/pages/sales-intelligence/sub-modules/common/types";
import {
    DEFAULT_SELECT_PANEL_ACCOUNT_ITEM,
    DEFAULT_SELECT_PANEL_ASSIGN_ITEM,
    DEFAULT_SELECT_PANEL_EXCEL_ITEM,
} from "app/pages/sales-intelligence/constants/common";

export const getMultiSelectorPanelConfig = (panel: TypeOfSelectors | null): Omit<MultiSelectorPanelType, "type"> => {
    switch (panel) {
        case TypeOfSelectors.ACCOUNT:
            return DEFAULT_SELECT_PANEL_ACCOUNT_ITEM;
        case TypeOfSelectors.EXCEL:
            return DEFAULT_SELECT_PANEL_EXCEL_ITEM;
        case TypeOfSelectors.ASSIGN:
            return DEFAULT_SELECT_PANEL_ASSIGN_ITEM;
        default:
            return {
                selectedMode: null,
                selectedItemIndex: 0,
            };
    }
};
